<div class="patient-card" [attr.data-testid]="biContainer" [attr.data-bi-attr-feature]="biFeature">
	<div class="patient-card-title">
		<div class="title-left">
			<span class="title-label">{{ tr('PatientSection.Patient') }}:</span>
			<div class="toggle-container" *ngIf="showInvisalignToggle" [class.toggle-container--off]="!isInvisalignToggleOn">
				<tlk-slide-toggle
					[id]="testIds.toggle"
					labelPosition="left"
					[ngModel]="isInvisalignToggleOn"
					(ngModelChange)="onInvisalignToggle()"
					[isDisabled]="isReadOnly || isOffline || invisalignState === 'selected'">
					{{ tr('PatientSection.CreateInvisalignPatient') }}
				</tlk-slide-toggle>
			</div>
		</div>
		<div class="title-center" *ngIf="headerMessage">
			<div class="link-message">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 17H7A5 5 0 0 1 7 7h2"></path><path d="M15 7h2a5 5 0 1 1 0 10h-2"></path><line x1="8" x2="16" y1="12" y2="12"></line></svg>
				<span>{{ tr(headerMessage) }}</span>
			</div>
		</div>
		<div class="title-right">
			<button tlkButton size="s" variant="primary" [attr.data-testid]="testIds.searchButton" (click)="onSearch()" *ngIf="showSearchButton" [disabled]="isOffline">
				<tlk-search-icon size="20"></tlk-search-icon>
				{{ tr('PatientSection.SearchPatient') }}
			</button>
			<button tlkButton size="s" variant="secondary" [attr.data-testid]="testIds.editButton" (click)="onEditorClicked()" *ngIf="showEditButton">
				{{ tr('PatientSection.Edit') }}
			</button>
			<button tlkButton size="s" variant="secondary" [attr.data-testid]="testIds.clearButton" *ngIf="!isReadOnly" [disabled]="!hasPatientData" (click)="onClear()">
				{{ tr('PatientSection.Clear') }}
			</button>
		</div>
	</div>

	<div class="patient-card-body">
		<div class="field-row">
			<tlk-text-input class="field"
				[label]="tr('PatientSection.FirstName')"
				[required]="true"
				[(ngModel)]="formFields.firstName"
				(ngModelChange)="onFieldUpdate('firstName')"
				[isDisabled]="!isEditable"
				name="firstName">
			</tlk-text-input>
			<tlk-text-input class="field"
				[label]="tr('PatientSection.LastName')"
				[required]="true"
				[(ngModel)]="formFields.lastName"
				(ngModelChange)="onFieldUpdate('lastName')"
				[isDisabled]="!isEditable"
				name="lastName">
			</tlk-text-input>
		</div>
		<div class="field-row">
			<rx-dob-input class="field"
				[label]="tr('PatientSection.DateOfBirth')"
				[required]="isInvisalignToggleOn && isEditable"
				[disabled]="!isEditable"
				[value]="parsedDateOfBirth"
				(valueChange)="onDobChanged($event)"
				translationPrefix="PatientSection">
			</rx-dob-input>
			<div class="field gender-field">
				<div class="gender-row">
					<span class="gender-label">{{ tr('PatientSection.Gender') }}<span class="gender-asterisk" [style.visibility]="isInvisalignToggleOn && isEditable ? 'visible' : 'hidden'">*</span></span>
					<tlk-radio-group class="gender-radio-group"
						[(ngModel)]="formFields.gender"
						(ngModelChange)="onFieldUpdate()"
						[disabled]="!isEditable"
						[required]="isInvisalignToggleOn && isEditable"
						name="patientCardGender">
						<tlk-radio-button value="Male" [label]="tr('PatientSection.Male')"></tlk-radio-button>
						<tlk-radio-button value="Female" [label]="tr('PatientSection.Female')"></tlk-radio-button>
					</tlk-radio-group>
				</div>
			</div>
		</div>
		<div class="field-row">
			<tlk-text-input class="field"
				[label]="tr('PatientSection.ChartNumber')"
				[(ngModel)]="formFields.chartNumber"
				(ngModelChange)="onFieldUpdate()"
				[isDisabled]="!isEditable"
				name="chartNumber">
			</tlk-text-input>
			<div class="field"></div>
		</div>
	</div>

	<div class="match-banner" *ngIf="cardMatchPatient">
		<tlk-banner type="warning">
			<div tlkBannerBody class="match-banner__content">
				<span class="match-banner__text">{{ tr('PatientSection.MatchExists') }} {{ cardMatchPatient.lastName }}, {{ cardMatchPatient.firstName }}</span>
				<button tlkButton variant="secondary" size="s" [attr.data-testid]="testIds.reviewMatchesButton" (click)="onReviewMatches()">
					{{ tr('PatientSection.ReviewAndImport') }}
				</button>
			</div>
		</tlk-banner>
	</div>
</div>

<div class="spinner-overlay" *ngIf="matchLoading">
	<rx-delayed-spinner [loading]="matchLoading"></rx-delayed-spinner>
</div>
